import Vuex from "vuex";
import Vue from "vue";
// import api from "../../axios/api";
import {
  CheckWantgo,
  AddWantGo,
  DeleteWantGo
} from "@/axios/service/travel.js";
Vue.use(Vuex);
const CheckDataStore = {
  namespaced: true,
  state: {
    wantNum: "", //该记录的想去玩的人数
    have: 0 //是否加过，0：没有添加 1：有添加
  },
  mutations: {
    wantNumMutations(state, value) {
      state.wantNum = value;
    },
    haveMutations(state, value) {
      state.have = value;
    }
  },
  actions: {
    //验证是否添加想去玩儿
    getCheckWantgo(context, params) {
      CheckWantgo(params).then(json => {
        if (json.respCode === 100 && json.result !== undefined) {
          context.commit("wantNumMutations", json.result.wantNum);
          context.commit("haveMutations", json.result.have);
        } else {
          // Global.messageErr('获取列表失败');
        }
      });
    },
    //添加
    getAddWantGo(context, params) {
      delete params.paramVue;
      AddWantGo(params).then(json => {
        if (json.respCode === 100 && json.result !== undefined) {
          context.commit("wantNumMutations", json.result.wantNum);
          context.commit("haveMutations", json.result.have);
        } else {
          // Global.messageErr('获取列表失败');
        }
      });
    },
    //删除
    getDeleteWantGo(context, params) {
      let paramVue = "";
      let fromMyTravel = false;
      // 如果来自my-travel页面
      if (params.data[0].fromPage && params.data[0].fromPage === "my-travel") {
        fromMyTravel = true;
        paramVue = params.data[0].vueParam;
        delete params.data[0].vueParam;
        delete params.data[0].fromPage;
      }
      DeleteWantGo(params).then(json => {
        if (json.respCode === 100 && json.result !== undefined) {
          context.commit("wantNumMutations", json.result.wantNum);
          context.commit("haveMutations", json.result.have);
          // 如果来自my-travel页面则需要调相应的查询方法
          if (fromMyTravel) {
            paramVue.findWantList(paramVue.wantdata);
          }
        } else {
          // Global.messageErr('获取列表失败');
        }
      });
    }
  }
};

export default CheckDataStore;
